
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8aT3t", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

var $dYBVS = parcelRequire("dYBVS");













/* TaskItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $8C5kA = parcelRequire("8C5kA");


var $flZlQ = parcelRequire("flZlQ");


var $7FcUt = parcelRequire("7FcUt");


var $fRWmC = parcelRequire("fRWmC");


var $gA5pn = parcelRequire("gA5pn");


var $1DWH0 = parcelRequire("1DWH0");


var $eWRwJ = parcelRequire("eWRwJ");

const $1168c8c3cdc7864c$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $1168c8c3cdc7864c$export$53eef0dcd9611650 = (0, $eWRwJ.default)($1168c8c3cdc7864c$export$7ba5d2eed2cf9f14);



var $iP9n7 = parcelRequire("iP9n7");

const $076a9a278050b060$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $flZlQ.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        ...props
    }); /**
                                                                                                                                                                                                                 * References packages/design-system/checkbox/src/checkbox.tsx
                                                                                                                                                                                                                 * To be used until mobile editor does not require legacy themed() API anymore,
                                                                                                                                                                                                                 * which will allow migration to use @atlaskit/checkbox instead
                                                                                                                                                                                                                 */ 
const $076a9a278050b060$var$checkboxStyles = null;
let $076a9a278050b060$var$taskCount = 0;
const $076a9a278050b060$var$getCheckBoxId = (localId)=>`${localId}-${$076a9a278050b060$var$taskCount++}`;
const $076a9a278050b060$var$TaskItem = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const checkBoxId = (0, $42omo.useMemo)(()=>$076a9a278050b060$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $42omo.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $1168c8c3cdc7864c$export$53eef0dcd9611650)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $42omo.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $42omo.useRef)(null);
    const inputRef = (0, $iP9n7.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        contentEditable: false,
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zidpf _i0dl1tcg _1bsb1tcg _4t3i1tcg _kqswh2mm _1wpzv2br _1snx1r31 _1746glyw _dx3f1o36 _1h5xidpf _sqizidpf _fs2cidpf _1smcidpf _oezm15vq _1l0615vq _1abj1mn3 _18a711so _16nprsbi _a27kkb7n _q3p7usvi _qhqx1nu9 _10cr1ssb _zfav1ssb _m7eu1ooe _l9o0n7od _1efjn7od _1u2istnw _32ro1j9a _1wn015vq _den5vp1g _zh8l1b66 _g5w3stnw _whhepxbi _1stbpxbi _18tob3bt _1awt1ule _haf81ssb _ra781ssb _cr751ooe _1q8r7vkz _9l2s7vkz _1mh7kb7n _s3uktlke _1davidpf _8bo8stnw _psnc1ssb _4k421ssb _1rvv1ooe _13vl73ad _1t711tcg _1nuz1tcg _cs4qstnw _9j2j1ssb _1mwj1ssb _19l51ooe _12yyl4ek _1miyrsbi _1umo1q28 _tpz25w2r _k6dg1q28 _1qduewfl _q8ftjmqp _1y9t5w2r _ut03jmqp _gi9hr01l _1qp61l7x _wxkgr01l _wo245w2r _c8dp1l7x _d2dcby5v _1eulby5v _1bc7by5v _16fmby5v _bhkuby5v _czfeby5v _1gxgby5v _19w0by5v _1x1y2sac"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                id: checkBoxId,
                "aria-label": formatMessage(isDone ? (0, $fRWmC.messages).markTaskAsNotCompleted : (0, $fRWmC.messages).markTaskAsCompleted),
                name: checkBoxId,
                type: "checkbox",
                onChange: handleOnChange,
                onClick: onClick,
                checked: !!isDone,
                disabled: !!disabled,
                suppressHydrationWarning: true,
                onKeyPress: handleOnKeyPress,
                ref: inputRef
            }),
            isDone ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FcUt))), {
                label: ""
            }) : /*#__PURE__*/ (0, $l998X.jsx)($076a9a278050b060$var$CheckboxUncheckedIcon, {
                label: ""
            })
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gA5pn.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId,
        children: children
    });
};
var $076a9a278050b060$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($076a9a278050b060$var$TaskItem);



var $ffCOo = parcelRequire("ffCOo");

class $1ae50d750c0a20b4$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $076a9a278050b060$export$2e2bcd8739ae039), {
                isDone: isDone,
                isRenderer: isRenderer,
                isFocused: isFocused,
                taskId: taskId,
                onChange: this.handleOnChange,
                onClick: this.handleOnClick,
                appearance: appearance,
                contentRef: contentRef,
                showPlaceholder: showPlaceholder,
                placeholder: placeholder,
                disabled: disabled,
                dataAttributes: dataAttributes,
                inputRef: inputRef,
                children: children
            })
        });
    }
    constructor(props){
        super(props);
        this.mounted = false;
        this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        };
        this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        };
        this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
}
$1ae50d750c0a20b4$export$2e2bcd8739ae039.defaultProps = {
    appearance: 'inline'
};



var $dh538 = parcelRequire("dh538");

function $45c96b04c90286eb$export$2e2bcd8739ae039(props) {
    const { objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch  {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    return (0, $dh538.fg)('platform_editor_fix_missing_task_id') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-task-local-id": props.taskId || '',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1ae50d750c0a20b4$export$2e2bcd8739ae039), {
            ...otherProps,
            objectAri: resolvedObjectId,
            isRenderer: isRenderer
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)((0, $1ae50d750c0a20b4$export$2e2bcd8739ae039), {
        ...otherProps,
        objectAri: resolvedObjectId,
        isRenderer: isRenderer
    });
}






var $brT61 = parcelRequire("brT61");

class $7e413b8c65bd5084$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dYBVS.WithProviders), {
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes, disableOnChange: disableOnChange } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $brT61.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $brT61.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $l998X.jsx)((0, $45c96b04c90286eb$export$2e2bcd8739ae039), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                disableOnChange: disableOnChange,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $4FxUL.default)();
    }
}
module.exports["default"] = $7e413b8c65bd5084$export$2e2bcd8739ae039;

});

parcelRegister("fRWmC", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $01fdfd6ac0ede0b3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    },
    markTaskAsCompleted: {
        id: "platform.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "platform.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    decisionAriaLabel: {
        id: "platform.taskDecision.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "platform.taskDecision.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["messages"] = $01fdfd6ac0ede0b3$export$defe85febe8b728c;

});

parcelRegister("gA5pn", function(module, exports) {
/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

function $df30472fd50f26c9$var$_defineProperty(e, r, t) {
    return (r = $df30472fd50f26c9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $df30472fd50f26c9$var$_toPropertyKey(t) {
    var i = $df30472fd50f26c9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $df30472fd50f26c9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $df30472fd50f26c9$var$placeholderStyles = null;
const $df30472fd50f26c9$var$placeholderTaskStyles = null;
const $df30472fd50f26c9$var$decisionStyles = null;
const $df30472fd50f26c9$var$contentStyles = null;
const $df30472fd50f26c9$var$taskStyles = null;
class $df30472fd50f26c9$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $gMc0m.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0tu8f _1reo15vq _18m915vq _kqswstnw _syaz1rpy _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza",
                itemType === 'TASK' && "_19pkidpf _2hwxidpf _otyridpf _18u0hwpb"
            ]),
            children: placeholder
        });
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $gMc0m.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhki8nm _kqswh2mm _14hd1wug"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $gMc0m.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}
$df30472fd50f26c9$var$_defineProperty($df30472fd50f26c9$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'inline'
});
module.exports["default"] = $df30472fd50f26c9$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("brT61", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $d33001fc1b36b5a2$var$defaultValue = [
    undefined,
    ()=>{}
];
const $d33001fc1b36b5a2$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($d33001fc1b36b5a2$var$defaultValue);
const $d33001fc1b36b5a2$var$reducer = (_state, action)=>{
    return action;
};
function $d33001fc1b36b5a2$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer($d33001fc1b36b5a2$var$reducer, undefined);
    return /*#__PURE__*/ (0, $l998X.jsx)($d33001fc1b36b5a2$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $d33001fc1b36b5a2$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d33001fc1b36b5a2$var$TaskItemsFormatContext);
}
function $d33001fc1b36b5a2$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($d33001fc1b36b5a2$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}
module.exports["TaskItemsFormatProvider"] = $d33001fc1b36b5a2$export$1ca88acfa8fef6b0;
module.exports["useTaskItemsFormatContext"] = $d33001fc1b36b5a2$export$617439880b48c653;
module.exports["TaskItemsFormatConsumer"] = $d33001fc1b36b5a2$export$be32c078f3ebeea0;

});


//# sourceMappingURL=taskItem.a74de9c8.js.map
